import { useMemo } from 'react';
import { ApiTransaction } from '../../../openapi';
import { groupTransactionsByDate } from './utils';
import { DateTime, ListContentIsland, Stack } from '@razz-team/ui-web';
import { TransactionListItem } from '../../Transaction/Transaction';

export function PagedTransactionsList({ pages }: { pages: { transactions: ApiTransaction[] }[] }) {
  const groups = useMemo(() => groupTransactionsByDate(pages), [pages]);

  return (
    <Stack gap={6} width="100%">
      {groups.map((group) => (
        <ListContentIsland
          title={<DateTime value={group.date} format="date" />}
          key={group.date.getTime()}
        >
          {group.transactions.map((transaction) => (
            <TransactionListItem transaction={transaction} key={transaction.id} />
          ))}
        </ListContentIsland>
      ))}
    </Stack>
  );
}
